import "@Styles/Shared/MyAccount/NewsletterSignup/anonymousNewsletterSignup_sm.less";
import "@Styles/Shared/MyAccount/PB/anonymousNewsletterSignup_sm.less";
import "@Styles/Shared/MyAccount/PB/anonymousNewsletterSignup_md.less";
import "@Styles/Shared/MyAccount/PB/anonymousNewsletterSignup_lg.less";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { anonymousSubscribe } from '../_api';
import { raiseNewsletterAnalyticsEvent, testRegex } from '../_util';
import { ANALYTICS_DUPLICATE_EVENT, ANALYTICS_OPT_IN_EVENT, EMAIL_REGEX, ZIP_CODE_REGEX } from '../_constants';
export default {
  props: {
    config: {
      type: Object
    },
    newsletter: {
      type: Object
    },
    hintText: {
      type: String
    },
    buttonText: {
      type: String
    },
    legalCopy: {
      type: String
    },
    enableExpandedFields: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      settings: this.config || {},
      email: {
        value: '',
        isValid: null,
        errorClass: '',
        errorMessage: this.config ? this.config.anonymousEmailInvalidErrorText : ''
      },
      zipCode: {
        value: '',
        isValid: null,
        errorClass: '',
        errorMessage: this.config ? this.config.zipCodeInvalidMessage : ''
      },
      languagePreference: {
        value: '',
        isValid: null,
        errorClass: '',
        errorMessage: this.config ? this.config.languagePreferenceRequiredMessage : ''
      },
      errorMessages: [],
      isButtonDisabled: false
    };
  },
  mounted: function mounted() {
    this.$_mounted();
  },
  methods: {
    focusSignup: function focusSignup() {
      this.$refs.anonymousEmail.focus();
    },
    subscribe: function subscribe() {
      var _this = this;

      this.isButtonDisabled = true;
      this.errorMessages = []; // Rerun validation

      if (!this.$_validate()) {
        this.isButtonDisabled = false;
        return;
      }

      if (this.newsletter) {
        anonymousSubscribe(this.newsletter, this.email.value, this.zipCode.value, this.languagePreference.value, this.enableExpandedFields, this.settings.sourceCodeOverride).then(function (responseJson) {
          return _this.$_onSubscribeSuccess(responseJson);
        }).catch(function (error) {
          return _this.$_onSubscribeError(error.message);
        });
      } else {
        this.$_onSubscribeError();
      }
    },
    // Temporary Method for AB testing
    subscribeWithEmail: function () {
      var _subscribeWithEmail = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(email) {
        var responseJson;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.email.value = email;
                this.isButtonDisabled = true;
                this.errorMessages = []; // Validation

                if (this.$_validate()) {
                  _context.next = 6;
                  break;
                }

                this.isButtonDisabled = false;
                return _context.abrupt("return", {
                  success: false,
                  errorMessages: this.errorMessages
                });

              case 6:
                _context.prev = 6;

                if (!this.newsletter) {
                  _context.next = 20;
                  break;
                }

                _context.next = 10;
                return anonymousSubscribe(this.newsletter, this.email.value, this.zipCode.value, this.languagePreference.value, this.enableExpandedFields, this.settings.sourceCodeOverride);

              case 10:
                responseJson = _context.sent;

                if (!(responseJson && responseJson.success)) {
                  _context.next = 16;
                  break;
                }

                this.$_onSubscribeSuccess(responseJson);
                return _context.abrupt("return", {
                  success: true,
                  errorMessages: []
                });

              case 16:
                this.$_onSubscribeError(responseJson ? responseJson.errorMessage : null);
                return _context.abrupt("return", {
                  success: false,
                  errorMessages: this.errorMessages
                });

              case 18:
                _context.next = 22;
                break;

              case 20:
                this.$_onSubscribeError();
                return _context.abrupt("return", {
                  success: false,
                  errorMessages: this.errorMessages
                });

              case 22:
                _context.next = 28;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](6);
                this.$_onSubscribeError(_context.t0.message);
                return _context.abrupt("return", {
                  success: false,
                  errorMessages: this.errorMessages
                });

              case 28:
                _context.prev = 28;
                this.isButtonDisabled = false;
                return _context.finish(28);

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 24, 28, 31]]);
      }));

      function subscribeWithEmail(_x) {
        return _subscribeWithEmail.apply(this, arguments);
      }

      return subscribeWithEmail;
    }(),
    $_validate: function $_validate() {
      var returnValue = true;
      this.$_validateEmail();
      if (this.email.isValid === false) returnValue = false;

      if (this.enableExpandedFields) {
        this.$_validateZipCode();
        this.$_validateLanguagePreference();
        if (this.zipCode.isValid === false || this.languagePreference.isValid === false) returnValue = false;
      }

      return returnValue;
    },
    $_validateEmail: function $_validateEmail() {
      var emailRegexCheck = testRegex(EMAIL_REGEX, this.email.value);

      if (!this.email.value || this.email.value.length === 0 || !emailRegexCheck) {
        this.email.isValid = false;
        this.email.errorClass = 'invalidInput';
        this.$_addErrorMessage(this.email.errorMessage);
      } else {
        this.email.isValid = true;
        this.email.errorClass = '';
        this.$_removeErrorMessage(this.email.errorMessage);
      }
    },
    $_validateZipCode: function $_validateZipCode() {
      var zipCodeRegexCheck = testRegex(ZIP_CODE_REGEX, this.zipCode.value);

      if (!this.zipCode.value || this.zipCode.value.length === 0 || !zipCodeRegexCheck) {
        this.zipCode.isValid = false;
        this.zipCode.errorClass = 'invalidInput';
        this.$_addErrorMessage(this.zipCode.errorMessage);
      } else {
        this.zipCode.isValid = true;
        this.zipCode.errorClass = '';
        this.$_removeErrorMessage(this.zipCode.errorMessage);
      }
    },
    $_validateLanguagePreference: function $_validateLanguagePreference() {
      if (!this.languagePreference.value || this.languagePreference.value.length === 0) {
        this.languagePreference.isValid = false;
        this.languagePreference.errorClass = 'invalidInput';
        this.$_addErrorMessage(this.languagePreference.errorMessage);
      } else {
        this.languagePreference.isValid = true;
        this.languagePreference.errorClass = '';
        this.$_removeErrorMessage(this.languagePreference.errorMessage);
      }
    },
    $_onSubscribeSuccess: function $_onSubscribeSuccess(response) {
      if (response && response.success) {
        // user was subscribed; show/hide messages as appropriate
        this.errorMessages = [];
        this.isButtonDisabled = false;
        var eventName = response.previouslySubscribed ? ANALYTICS_DUPLICATE_EVENT : ANALYTICS_OPT_IN_EVENT;
        raiseNewsletterAnalyticsEvent(eventName, this.newsletter, this.settings.location, response.updateCode);
        this.$emit('subscribed', {
          email: this.email.value,
          zipCode: this.zipCode.value,
          languagePreference: this.languagePreference.value
        });
      } else {
        this.$_onSubscribeError(response ? response.errorMessage : null);
      }
    },
    $_onSubscribeError: function $_onSubscribeError(message) {
      this.isButtonDisabled = false;
      var errorMessage = message ? message : this.settings.anonymousSubscribeErrorText;
      this.$_addErrorMessage(errorMessage);
    },
    $_addErrorMessage: function $_addErrorMessage(message) {
      if (!this.errorMessages.includes(message)) this.errorMessages.push(message);
    },
    $_removeErrorMessage: function $_removeErrorMessage(message) {
      var errorMessageIndex = this.errorMessages.indexOf(message);
      if (errorMessageIndex > -1) this.errorMessages.splice(errorMessageIndex, 1);
    },
    $_mounted: function $_mounted() {
      //Temporary Method for AB testing
      GeneralMills.PandoSites.NewsletterCta.SignUp.Subscribe = this.subscribeWithEmail;
    }
  }
};